/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		4:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "" + chunkId + "." + ({}[chunkId]||chunkId) + ".js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/thema/kunstwacht/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _ChangeTheme = __webpack_require__(38);
	
	var _ChangeTheme2 = _interopRequireDefault(_ChangeTheme);
	
	var _Loader = __webpack_require__(40);
	
	var _Loader2 = _interopRequireDefault(_Loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Index = function Index() {
	  var _this = this;
	
	  _classCallCheck(this, Index);
	
	  var menuEl = document.querySelector('nav .menu.list');
	  var bannerEl = document.querySelector('.banner_slider');
	  var homeSlidesEl = document.querySelector('.home_slides');
	  var pagesEl = document.querySelector('.headline__panel.pages');
	  this.body = document.querySelector('body');
	  this.loader = new _Loader2.default();
	
	  new _ChangeTheme2.default(window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight || 0, 100);
	
	  if (menuEl) {
	    __webpack_require__.e/* nsure */(3, function (require) {
	      var Menu = __webpack_require__(18).default;
	      new Menu(menuEl);
	    });
	  }
	
	  if (bannerEl) {
	    __webpack_require__.e/* nsure */(2, function (require) {
	      var Banner = __webpack_require__(15).default;
	      new Banner(bannerEl);
	    });
	  }
	  if (pagesEl) {
	    __webpack_require__.e/* nsure */(1, function (require) {
	      var IndiScroller = __webpack_require__(17).default;
	      new IndiScroller();
	    });
	  }
	
	  if (homeSlidesEl) {
	    __webpack_require__.e/* nsure */(0, function (require) {
	      var Etalage = __webpack_require__(16).default;
	      new Etalage(homeSlidesEl);
	    });
	  }
	  this.loader.onReady(function () {
	    _this.body.className = 'loaded ' + _this.body.className;
	    var mainPanel = document.querySelector('body.loaded .main__panel');
	    if (mainPanel) {
	      if (!mainPanel.style.opacity) {
	        mainPanel.style.opacity = 1;
	        _this.body.className = ' ' + _this.body.className;
	        setTimeout(function () {
	
	          _this.body.className = 'loaded ' + _this.body.className;
	        }, 500);
	      }
	    }
	  });
	};
	
	window.addEventListener('load', new Index());

/***/ }),

/***/ 38:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ChangeTheme = function () {
	    function ChangeTheme(targetPos, margin) {
	        _classCallCheck(this, ChangeTheme);
	
	        this.pos = targetPos;
	        this.margin = margin;
	        this.bodyEl = document.querySelector('body');
	        this.startTimer();
	    }
	
	    _createClass(ChangeTheme, [{
	        key: 'startTimer',
	        value: function startTimer() {
	            var _this = this;
	
	            this.timer = setInterval(function () {
	                return _this.testScroll();
	            }, 250);
	        }
	    }, {
	        key: 'testScroll',
	        value: function testScroll() {
	            if (document.body.scrollTop > this.pos - this.margin) {
	                this.bodyEl.className = this.bodyEl.className.indexOf('dark') > -1 ? this.bodyEl.className : 'dark ' + this.bodyEl.className;
	            } else {
	                this.bodyEl.className = this.bodyEl.className.replace(/dark\s/g, '');
	            }
	        }
	    }]);
	
	    return ChangeTheme;
	}();
	
	exports.default = ChangeTheme;

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Loader = function () {
	    function Loader() {
	        _classCallCheck(this, Loader);
	
	        this.body = document.querySelector('body');
	        this.render();
	    }
	
	    _createClass(Loader, [{
	        key: 'render',
	        value: function render() {
	            this.logo = document.createElement('span');
	            this.logo.className = 'i-logo_kunstwacht loader_logo';
	            this.body.appendChild(this.logo);
	        }
	    }, {
	        key: 'onReady',
	        value: function onReady(callback) {
	            var _this = this;
	
	            setTimeout(function () {
	                _this.logo.className = 'i-logo_kunstwacht loader_logo hide';
	                callback();
	            }, 500);
	        }
	    }]);
	
	    return Loader;
	}();
	
	exports.default = Loader;

/***/ })

/******/ });


// WEBPACK FOOTER //
// index.js